import React from 'react';
import styled from 'styled-components';

import media from '../../../utils/mediaQueries';
import Icon from '../../../images/icon-success.inline.svg';
import { FONT_FAMILY_MAIN, TEXT_COLOR } from '../../../theme';
import { ShareReviewMessage } from '../ShareReviewMessage';
import { Intro } from '../../LeadForm/Intro';
import { Form } from '../../LeadForm/Form';
import stores from '../../../stores';

type SuccessMessageWithOfferProps = {
  city: string;
  zipcode: string;
  phone: string;
  firstName: string;
  placeId: string;
  rating: number;
  reviewId: string;
  email: string;
};

const Body = styled.div`
  padding: 88px 98px 40px;
  font-size: 18px;

  ${media.mobile`
    padding: 24px;
  `}
`;

const IconSuccess = styled(Icon)`
  width: 48px;
  height: 48px;
  display: block;
  margin: 0 auto;
  
  ${media.mobile`
    width: 32px;
    height: 32px;
  `}
`;

const Title = styled.h4`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.2px;
  color: ${TEXT_COLOR};
  margin: 32px 0 8px;
  text-align: center;
  
  ${media.mobile`
    font-size: 18px;
    line-height: 1.44;
    margin-top: 8px;
  `}
`;

const Message = styled.div`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: ${TEXT_COLOR};
  max-width: 437px;
  margin: 48px auto 0;
`;

const SuccessMessageWithOffer = ({
  city, zipcode, phone, firstName, rating, reviewId, placeId, email,
}: SuccessMessageWithOfferProps) => {
  const initialValues = {
    zipcode: zipcode || '',
    phone: phone || '',
    message: '',
  };

  const handleSubmit = (values, { setStatus, setSubmitting }) => {
    stores.leadsStore.create({
      lead: {
        phone: values.phone,
        email,
        codepostal: values.zipcode,
        message: values.message,
      },
    }, setStatus, setSubmitting);
  };

  return (
    <Body>
      <IconSuccess />
      <Title>{`${firstName}, merci pour votre avis !`}</Title>
      <Intro city={city} />
      <Form initialValues={initialValues} handleSubmit={handleSubmit} />
      {placeId && reviewId && rating > 3 && (
        <Message>
          <ShareReviewMessage reviewId={reviewId} isExamCenter />
        </Message>
      )}
    </Body>
  );
};

export { SuccessMessageWithOffer };
